// Inline pencil / "Edit page" UI was removed per product decision — it
// fought normal user flows (logout, registration) on mobile and the
// inline pencil clicks felt unresponsive. Admin can still edit copy via
// the Admin page → Site Copy editor grid.
//
// We keep this file as a shim so existing imports (`<T />`, `EditModeProvider`)
// don't break. `<T>` is now a plain pass-through wrapper around `t()` —
// renders the translated string in the chosen tag, supports `vars` for
// interpolation. `EditModeProvider` is a no-op wrapper that just renders
// its children.

import { useT } from "@/i18n";

export function EditModeProvider({ children }) {
  return children;
}

export function T({ k, vars, as: Tag = "span", className = "" }) {
  const { t } = useT();
  return <Tag className={className}>{t(k, vars)}</Tag>;
}
